import { FiscalDataUi } from '@/components/Buyer/BuyerProfile/PaymentAndFiscalData/FiscalData/FiscalDataUi';
import { BuyerFiscalDataResponse } from '@/data/api/model/buyers/BuyersDto';
import { produce } from 'immer';

export function buyerFiscalDataResponseToFiscalDataUi(
  fiscalDataUi: FiscalDataUi,
  input: BuyerFiscalDataResponse
) {
  return produce(fiscalDataUi, (draft) => {
    draft.taxInvoiceRequired = input.require_invoice;
    draft.rfc = input.tax_id ?? '';
    draft.legalName = input.legal_name ?? '';
    draft.postalCode = input.zip_code ?? '';
    draft.taxEmail = input.email ?? '';
    draft.fiscalRegime = input.tax_regime_id ?? '';
    draft.cfdiUse = input.cfdi_use_id ?? '';
    draft.cancelDisabled = true;
    draft.saveDisabled = true;
  });
}
